import { render, staticRenderFns } from "./selectCity.vue?vue&type=template&id=154d2bd2&scoped=true&"
import script from "./selectCity.vue?vue&type=script&lang=js&"
export * from "./selectCity.vue?vue&type=script&lang=js&"
import style0 from "./selectCity.vue?vue&type=style&index=0&id=154d2bd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d2bd2",
  null
  
)

export default component.exports